export const COMPANY_FIELDS = {
  tradeDbaName: 'tradeDbaName',
  legalName: 'legalName',
  parentCompany: 'parentCompany'
};

export const DELIVERY_DETAILS_FIELDS = {
  appointmentRequired: 'appointmentRequired',
  receivingPlantContactName: 'receivingPlantContactName',
  receivingPlantPhoneNumber: 'receivingPlantPhoneNumber',
  afterHoursContactName: 'afterHoursContactName',
  afterHoursPhoneNumber: 'afterHoursPhoneNumber',
  warehouseReceivingHours: 'warehouseReceivingHours'
};

export const DELIVERY_INSTRUCTIONS_FIELDS = {
  shippingInstructions: 'shippingInstructions',
  customsText: 'customsText',
  externalInvoiceText: 'externalInvoiceText',
  loadingInstructions: 'loadingInstructions',
  unloadingInstructions: 'unloadingInstructions',
  packingInstructions: 'packingInstructions',
  billOfLadingText: 'billOfLadingText',
  textNotaFiscal: 'textNotaFiscal',
  shippingMarks: 'shippingMarks'
};

export const SOLD_TO_ADDRESS_FIELDS = {
  address: 'address',
  taxExempt: 'taxExempt',
  dnbNumber: 'dnbNumber',
  zonaFranca: 'zonaFranca',
  fiscalId: 'fiscalId',
  taxNumber1: 'taxNumber1',
  taxNumber2: 'taxNumber2',
  taxNumber3: 'taxNumber3',
  taxNumber4: 'taxNumber4',
  district: 'district',
  taxType: 'taxType',
  icmsTaxPayer: 'icmsTaxPayer',
  suframa: 'suframa',
  email: 'email',
  naturalPerson: 'naturalPerson',
  telephone1: 'telephone1',
  telephone2: 'telephone2',
  xmlEmail: 'xmlEmail',
  paymentSlipEmail: 'paymentSlipEmail',
  legalName: 'legalName',
  tradeDbaName: 'tradeDbaName'
};

export const BILL_TO_ADDRESS_FIELDS = {
  address: 'address',
  taxNumber1: 'taxNumber1',
  taxNumber2: 'taxNumber2',
  taxNumber3: 'taxNumber3',
  taxNumber4: 'taxNumber4',
  district: 'district',
  naturalPerson: 'naturalPerson'
};

export const SHIP_TO_ADDRESS_FIELDS = {
  address: 'address',
  taxExempt: 'taxExempt',
  dnbNumber: 'dnbNumber',
  email: 'email',
  taxNumber1: 'taxNumber1',
  taxNumber2: 'taxNumber2',
  taxNumber3: 'taxNumber3',
  taxNumber4: 'taxNumber4',
  telephone1: 'telephone1',
  telephone2: 'telephone2',
  naturalPerson: 'naturalPerson'
};

export const PAYER_ADDRESS_FIELDS = {
  address: 'address',
  taxNumber1: 'taxNumber1',
  taxNumber2: 'taxNumber2',
  taxNumber3: 'taxNumber3',
  taxNumber4: 'taxNumber4',
  email: 'email',
  telephone1: 'telephone1',
  telephone2: 'telephone2',
  district: 'district',
  dnbNumber: 'dnbNumber',
  naturalPerson: 'naturalPerson',
  xmlEmail: 'xmlEmail',
  paymentSlipEmail: 'paymentSlipEmail'
};

export const CONTACT_FIELDS = {
  email: 'email',
  fax: 'fax'
};

export const ATTACHMENT_FIELDS = {
  addressAttachment: 'addressAttachment',
  taxAttachment: 'taxAttachment',
  ineAttachment: 'ineAttachment',
  financialStatementsAttachment: 'financialStatementsAttachment',
  constitutiveActAttachment: 'constitutiveActAttachment',
  taxExemptAttachment: 'taxExemptAttachment',
  financialCardAttachment: 'financialCardAttachment',
  additionalAttachment: 'additionalAttachment'
};

export const INVOICE_DELIVERY_FIELDS = {
  ...CONTACT_FIELDS,
  mailToBillTo: 'mailToBillTo'
};

export const CONTACT_SAME_AS_FIELDS = {
  sameAsInvoiceDelivery: 'sameAsInvoiceDelivery',
  sameAsCoa: 'sameAsCoa',
  sameAsPackingList: 'sameAsPackingList'
};

export const SAME_AS_CONTACT_TRANSLATIONS_MAP = {
  [CONTACT_SAME_AS_FIELDS.sameAsInvoiceDelivery]: 'sameAsContact.invoiceDelivery',
  [CONTACT_SAME_AS_FIELDS.sameAsCoa]: 'sameAsContact.coa',
  [CONTACT_SAME_AS_FIELDS.sameAsPackingList]: 'sameAsContact.packingList'
};

export const ACCOUNTS_PAYABLE_FIELDS = {
  name: 'name',
  title: 'title',
  email: 'email',
  phoneNumber: 'phoneNumber'
};

export const BANKER_CONTACT_FIELDS = {
  contactName: 'contactName',
  phoneNumber: 'phoneNumber',
  email: 'email'
};

export const BANK_REFERENCE_FIELDS = {
  name: 'name',
  routingNumber: 'routingNumber',
  accountNumber: 'accountNumber',
  address: 'address',
  faxNumber: 'faxNumber',
  bankKey: 'bankKey',
  clabe: 'clabe',
  iban: 'iban',
  country: 'country',
  accountAttachment: 'accountAttachment'
};
